export const welcomeDescription = "With the Annual Survey of Colleges, you can easily share information about your institution to help prospective students learn more about you.";

export const profileUpdateTitle = "Update Your BigFuture Profile";
export const profileUpdateDesc = "It’s quick and easy to keep your profile on BigFuture up to date with the information students search for the most. To get started, you can check out how students view your profile now, or make updates directly.";
export const profileButtonOne = "View Your Profile";
export const profileButtonTwo = "Update";



export const lastUpdateTitle = "Last update to your profile:";
export const lastUpdateDesc = "by -- --";



export const referenceTitle = "1,098,000 students";
export const referenceDesc = "Viewed profiles like yours this year";

export const mediaFileTitle = 'Upload your banners and logos';
export const mediaFileDesc = 'Please provide up to date logos and banners for your institution. This is also an opportunity to adjust seasonally based on your institution’s recruitment strategy.';

export const helpSectionTitle = "Have questions? We're here to help";
export const helpSectionDesc = "Reach out with any questions you may have as you provide information for your college’s profile";

export const emailContactUs = "mailto:collegesurvey@collegeboard.org";
export const emailCDS = "mailto:collegesurvey@collegeboard.org";

export const supportSiteLabel = 'Visit Support Site';

//Sidebar Constants
export const adminView = 'Admin Overview';
export const cdsView = 'Review CDS';
export const bgColors = {
    Grey: '#F5F7FC',
};
